export default "<div class=\"home-view\">\r\n    <app-project-home #ProjectHomeView></app-project-home>\r\n</div>\r\n"